import {
  IBackofficeCompany,
  IBackofficeCompanyTeamMemberStats,
} from '../../types/backoffice.types';
import { sendRequestToDoSelectCentralService } from '../../utils/request';
import { HTTP_METHODS } from '../../constants/HttpConstants';

export const getCompanyDetails = (companySlug: string) => {
  return sendRequestToDoSelectCentralService<IBackofficeCompany[]>({
    method: HTTP_METHODS.GET,
    url: `/backoffice/company/${companySlug}`,
  }).then((response) => response.data);
};

export const getUserDetails = (username: string) => {
  return sendRequestToDoSelectCentralService<IBackofficeCompany[]>({
    method: HTTP_METHODS.GET,
    url: `/backoffice/users/${username}`,
  }).then((response) => response.data);
};

export const getLazyLoginTokenApi = ({
  username,
  companySlug,
}: {
  username: string;
  companySlug: string;
}) => {
  return sendRequestToDoSelectCentralService<{ url: string }>({
    method: HTTP_METHODS.GET,
    url: `/backoffice/company/${companySlug}/recruiter/${username}/get_token`,
  }).then((response) => response.data);
};

export const getLedgerDetailsApi = ({
  offset,
  productType,
  limit,
  from,
  to,
  companySlug,
}: {
  offset: number;
  productType: string;
  limit: number;
  from: Date;
  to: Date;
  companySlug: string;
}) => {
  let queryURl = `company_slug=${companySlug}&limit=${limit}`;
  queryURl = from ? `${queryURl}&created_from=${from}` : queryURl;
  queryURl = to ? `${queryURl}&created_to=${to}` : queryURl;
  queryURl = productType ? `${queryURl}&product_type=${productType}` : queryURl;
  queryURl = offset ? `${queryURl}&offset=${offset}` : queryURl;

  return sendRequestToDoSelectCentralService<{ url: string }>({
    method: HTTP_METHODS.GET,
    url: `/pin-service/api/v1/search/ledger/?${queryURl}`,
  }).then((response) => response.data);
};

export const getBackofficeCompanyQuotaDetailsAPI = (
  companySlug: string,
  username: string
) => {
  return sendRequestToDoSelectCentralService<IBackofficeCompany[]>({
    method: HTTP_METHODS.GET,
    url: `/rpc/billing.get_team_quotas?company=${companySlug}&__env=PLT&__user=${username}`,
  });
};

export const getBackofficeCompanyMonthlyStatsAPI = (
  companySlug: string,
  username: string
) => {
  return sendRequestToDoSelectCentralService<IBackofficeCompany[]>({
    method: HTTP_METHODS.GET,
    url: `/rpc/team.get_monthly_stats?company=${companySlug}&__env=PLT&__user=${username}`,
  });
};

export const getBackofficeCompanyTeamMembersStatsAPI = (
  companySlug: string,
  username: string
) => {
  return sendRequestToDoSelectCentralService<
    IBackofficeCompanyTeamMemberStats[]
  >({
    method: HTTP_METHODS.GET,
    url: `/rpc/team.get_member_stats?company=${companySlug}&__env=PLT&__user=${username}`,
  });
};
